// extracted by mini-css-extract-plugin
export var childrenContainer = "_4y-0";
export var virtualScrollArea = "_4y-1";